import Vue from "vue";

Vue.filter('price', (p, decimals = 2) => isNaN(p) ? p : p.toFixed(decimals));
